import { TemplateKey } from "PFApp/constants/templates";
import { Button, ButtonProps } from "PFComponents/button";
import { DropdownOption } from "PFComponents/dropdown/dropdown";
import { DropdownButton } from "PFComponents/dropdown_button";
import { Icon } from "PFComponents/icon";
import { Typography } from "PFComponents/typography";
import { useSubtemplates } from "PFCore/hooks/queries/subtemplates/use_subtemplates";
import { Subtemplate } from "PFTypes";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

type AddRoleButtonProps = {
  buttonKind?: ButtonProps["kind"];
  onChange: (subtemplate?: Subtemplate) => void;
};

export const AddRoleWithSubtemplateButton = ({ buttonKind = "secondary", onChange }: AddRoleButtonProps) => {
  const { data: subtemplates = [], isFetching } = useSubtemplates({ templateKey: TemplateKey.Role });
  const { t } = useTranslation("activities", { keyPrefix: "engagementBlueprint" });

  const options: DropdownOption[] = useMemo(
    () =>
      subtemplates.map((subtemplate) => ({
        id: subtemplate.subtemplate_key,
        displayElement: subtemplate.subtemplate_title,
        item: subtemplate
      })),
    [subtemplates]
  );

  if (subtemplates.length === 0) {
    return <Button kind={buttonKind} text={t("addRole")} disabled={isFetching} onClick={() => onChange()} />;
  }

  return (
    <DropdownButton
      options={options}
      disabled={isFetching}
      handleChange={(subtemplate: Subtemplate) => {
        onChange(subtemplate);
      }}
      buttonKind={buttonKind}
    >
      <Typography variant="bodyButtons">{t("addRole")}</Typography>
      <Icon name="chevron-down" size="sm" />
    </DropdownButton>
  );
};
